$ = require 'jquery'
GoogleApi = require 'lib/google-api'

# Load the js api immediately
$.getScript('https://apis.google.com/js/api.js', -> GoogleApi.loadedAuth())



// WEBPACK FOOTER //
// ./app/scripts/entry/load-gapi.coffee